module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("January 8 (Blueberries)")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Breakfast: two clementines and a blueberry yogurt while reading Neruda on the porch. The students are agitating for me to teach the Whitman & Neruda seminar, a class I have promised and failed to deliver for how many years now? “Ode to Criticism.” “Ode to Eel Chowder.” Read this week that blueberries have been determined to be a nutritional super food, a mighty antioxidant endowed with mysterious power to supercharge the brain and all but assure eternal life. Yes, but will they cure my aching feet? My policy is to ignore bodily afflictions for at least six months, but my days of running on the beach appear to be at an end. Temporarily, I’d like to believe. I am a good patient, performing all the podiatrically prescribed exercises and therapeutic routines–ice, stretching, a stupid boot I must wear to sleep like an antipodal dunce cap to passively stretch my plantar fascia, the tendonlike bundle of tissue that underlies the arch of the foot and bears upon it the body’s weight, anatomical detail of which I have resided in delightful ignorance heretofore. As a rule, you notice the plantar fascia only when it cries out in pain. And then, if you continue to run on it, for weeks, and even months, I suppose you get what you deserve. Swimming is better anyway–I should take a swim in the ocean! But school is in session–there is work to be done! Beautiful morning, sunny and cool, the archway hidden beneath cascading alamanda blossoms the color of Irish butter. No, I do not feel like working, or exercising: I feel like reading poetry. “Ode to Laziness.” “Ode to Walt Whitman.” Still cannot grasp Neruda to my satisfaction. There is about him something of the conger eel, I believe. And something of the plantar fascia. And something of the blueberry.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a4fb5e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 78
// module chunks = 0